import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  GetGeogDetails,
  AddGeog,
  DeleteGeog,
  UpdateGeog,
  ImportGEO,
  GetGeogDetails_Paging_Search,
} from "../../../../api/User/ACG/GEOApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import { GetCBSA } from "../../../../api/User/ACG/CBSAApi";
import { DownloadCensusErrorFile } from "../../../../api/User/ACG/ImportCensusApi";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  zip_Code: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter zip code"),
  city: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter city"),
  state: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter state"),
  country: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter country"),
  county_Long: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter county long"),
  county_Short: Yup.string()
    .matches(/^[a-zA-Z0-9\s-]*$/, "No special characters are allowed.")
    .required("Please enter county short"),
  cmsa: Yup.string()
    .notOneOf(["Select CBSA"], "Invalid value")
    .required("Please select CBSA"),
  coci: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter COCI"),
});

const GEO = () => {
  const [data, setData] = useState([]);
  const [showTable, setShowTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState({ isModal: false, file: "" });
  const [selectedRow, setSelectedRow] = useState(null);
  const [importedFile, setImportedFile] = useState(null);
  const [cbsaData, setCbsaData] = useState([]);
  const buttonRef = useRef(null);
  const fileInputRef = useRef(null);
  const column = [
    {
      title: "Zip Code",
      field: "zip_Code",
    },
    {
      title: "City",
      field: "city",
    },
    {
      title: "State",
      field: "state",
    },
    {
      title: "Country",
      field: "country",
    },
    {
      title: "County (Long)",
      field: "county_Long",
    },
    {
      title: "County (Short)",
      field: "county_Short",
    },
    {
      title: "CBSA",
      field: "cmsa",
    },
    {
      title: "COCI",
      field: "coci",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
  }, [showModal]);

  useEffect(() => {
    // getGeogDetailsData();
    GetCBSA().then((res) => {
      if (res.status === 200 || res.status === 204) {
        setCbsaData(res.data);
      }
    });
  }, []);

  useEffect(() => {
    const importedFileName = importedFile?.name;
    const importedFileFormat = importedFileName?.substring(
      importedFileName.lastIndexOf(".") + 1
    );

    if (importedFile) {
      if (importedFileFormat !== "csv") {
        toastFile("invalid file");
        setImportedFile(null);
        return;
      }

      const formData = new FormData();
      formData.append("files", importedFile);
      setShowTable(false);
      // console.log(formData);
      ImportGEO(formData)
        .then((res) => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.success) {
              setShowTable(true);
              toastFile("imported");
            } else {
              if (res.data.message === "failed") {
                setMessage((prev) => ({
                  file: res.data.file,
                  isModal: true,
                }));
              } else {
                toastFile("File Not Uploaded");
              }
            }
            setImportedFile(null);
          }
        })
        .finally((res) => setShowTable(true))
        .catch((err) => {
          console.log({ err });
        });
    }
  }, [importedFile]);

  // const getGeogDetailsData = () => {
  //   GetGeogDetails()
  //     .then((res) => {
  //       if (res.status === 200 || res.status === 204) {
  //         setData(res.data);
  //       }
  //     })
  //     .catch((err) => console.log({ err }));
  // };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;
    const {
      zip_Code,
      city,
      state,
      country,
      county_Long,
      county_Short,
      cmsa,
      coci,
    } = values;
    const payload = {
      id: 0,
      zip_Code,
      city,
      state,
      country,
      city_State: city + state,
      cmsa,
      coci: +coci,
      cmsA_Short: "",
      last_COCI_Calc_Date: new Date().toISOString(),
      county_Long,
      county_Short,
    };

    if (witchAction === "add") {
      setShowTable(false);
      AddGeog(payload)
        .then((res) => {
          if (res.status === 200 || res.status === 204) {
            toastFile("new");
            setShowModal(false);
          } else if (res?.response?.status === 400) {
            toastFile(res?.response?.data, "error");
            setShowModal(false);
          }
        })
        .finally((res) => setShowTable(true));
    } else if (witchAction === "update") {
      setShowTable(false);
      UpdateGeog(selectedRowData.id, {
        ...payload,
        id: selectedRowData.id,
      })
        .then((res) => {
          if (res.status === 200 || res.status === 204) {
            toastFile("update");
            setShowModal(false);
          } else if (res?.response?.status === 400) {
            toastFile(res?.response?.data, "error");
            setShowModal(false);
          }
        })
        .finally((res) => setShowTable(true));
    }
  };

  return (
    <div>
      <Modal
        show={message.isModal}
        onHide={() => setMessage((prev) => ({ ...prev, isModal: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            Below records could not be imported. Please check following possible
            issues:
          </div>
          <ol>
            <li>Zip_Code is not in 5-digits format.</li>
            <li>Number columns is blank.</li>
            <li>
              Number columns are populated with something other than numbers.
            </li>
          </ol>
          <div className="mt-3">
            Please click the link below to down load the error list:
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              className="bg-transparent border-0 text-primary"
              onClick={() => {
                DownloadCensusErrorFile(message.file).then((data) => {
                  const blob = new Blob([data.data], {
                    type: "text/plain",
                  });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = message.file;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                  setMessage((prev) => ({ isModal: false, file: "" }));
                });
              }}
            >
              Download Error Log
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            GEO
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                setShowTable(false);
                DeleteGeog(selectedRowData?.id)
                  .then((res) => {
                    if (res.status === 200 || res.status === 204) {
                      toastFile("delete");
                      //setIsGetData(true);
                      setShowModal(false);
                    }
                  })
                  .catch((err) => console.log(err))
                  .finally(() => setShowTable(true));
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                zip_Code: selectedRowData?.zip_Code,
                city: selectedRowData?.city,
                state: selectedRowData?.state,
                country: selectedRowData?.country,
                county_Long: selectedRowData?.county_Long,
                county_Short: selectedRowData?.county_Short,
                cmsa: selectedRowData ? selectedRowData.cmsa : "Select CBSA",
                coci: selectedRowData ? selectedRowData.coci : 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              Zip Code
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name="zip_Code"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.zip_Code}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.zip_Code && errors.zip_Code}
                              placeholder="Zip Code"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.zip_Code}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              City
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name="city"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.city}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.city && errors.city}
                              type="text"
                              placeholder="City"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.city}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              State
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name="state"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.state}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.state && errors.state}
                              type="text"
                              placeholder="State"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.state}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              Country
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name="country"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.country}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.country && errors.country}
                              type="text"
                              placeholder="Country"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.country}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              County (Long)
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name="county_Long"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.county_Long}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.county_Long && errors.county_Long
                              }
                              type="text"
                              placeholder="County (Long)"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.county_Long}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              County (Short)
                              <Required />
                            </Form.Label>
                            <Form.Control
                              name="county_Short"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.county_Short}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.county_Short && errors.county_Short
                              }
                              type="text"
                              placeholder="County (Short)"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.county_Short}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              CBSA
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="rounded-0"
                              style={Fontstyling.label}
                              name="cmsa"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                values.cmsa === "Select CBSA" && touched.cmsa
                              }
                            >
                              <option value={"Select CBSA"}>Select CBSA</option>
                              {cbsaData.map(({ ID, CMSA: item }, index) => (
                                <option
                                  value={item}
                                  selected={values.cmsa === item}
                                >
                                  {item}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              Please select CBSA
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col>
                          <CustomInputField
                            label="COCI"
                            name="coci"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <a
          className="me-3"
          href="/samplefile/GEO_Import_Template.csv"
          style={{
            textDecoration: "none",
          }}
          onMouseOver={(e) => {
            e.target.style.textDecoration = "underline";
          }}
          onMouseOut={(e) => {
            e.target.style.textDecoration = "none";
          }}
          download
        >
          Download Template
        </a>

        <CustomButton
          onClick={() => {
            fileInputRef.current.click();
          }}
        >
          Import GEO
        </CustomButton>
        <input
          type="file"
          ref={fileInputRef}
          onChange={(event) => {
            setImportedFile(event.target.files[0]);
            event.target.value = "";
          }}
          style={{ display: "none" }}
        />

        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add GEO
        </CustomButton>
      </div>
      {showTable && (
        <CustomMaterialTable
          column={column}
          data1={data}
          data={(query) =>
            new Promise((resolve, reject) => {
              GetGeogDetails_Paging_Search(
                query.page,
                query.pageSize,
                query.search
              ).then((result) => {
                setData(result.data.geog);
                resolve({
                  data: result.data.geog,
                  page: query.page,
                  totalCount: result.data.geogTotalPage * query.pageSize,
                });
              });
            })
          }
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          setWitchAction={setWitchAction}
          setSelectedRowData={setSelectedRowData}
          setShowModal={setShowModal}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default GEO;
